import { Navigate } from '@tanstack/react-router'
import { Loader2 } from 'lucide-react'
import type { ReactNode } from 'react'
import { useCurrentUserQuery } from '../../../hooks/api'
import { useSession } from '../../../lib/auth'

export function AdminGuard({ children }: { children: ReactNode }) {
  const { data: session, isPending: isSessionPending } = useSession()
  const { data: user, isPending: isUserPending } = useCurrentUserQuery({ enabled: !!session })

  if (isSessionPending || (session && isUserPending)) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="size-6 animate-spin text-muted-foreground" />
      </div>
    )
  }

  if (!session) {
    return <Navigate to="/app" />
  }

  if (user?.role !== 'ADMIN') {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-2">
        <h1 className="text-lg font-semibold">Not Authorized</h1>
        <p className="text-sm text-muted-foreground">You need admin access to view this page.</p>
      </div>
    )
  }

  return <>{children}</>
}
